import React, { useState, useEffect } from 'react';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage, useForm } from '@laramie/ui';
import { number, func } from 'prop-types';
import { Loading, TableCustom, FormLabel, FormError } from '../../common';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import { useFormErrors } from '../../hooks/useFormErrors';
import { getDateToString, getFormatNumber, getNumeroRecibo_ObjectToString } from '../../../utils/convert';
import { useEntidad } from '../../hooks/useEntidad';
import { APIS } from '../../../config/apis';
import { ServerRequest } from '../../../utils/apiweb';
import { PERMISSIONS } from '../../../consts/permissions';
import { usePermissions } from '../../hooks/usePermissions';
import CuentaDebitosCreditosGrid from '../CuentaDebitosCreditosGrid';


const CuentaAplicacionCreditosModal = (props) => {

    //hooks
    const [state, setState] = useState({
        idCuenta: 0,
        idTipoTributo: 0,
        loading: false,
        showFormDebitoCredito: false
    });

    const [listCreditos, setListCreditos] = useState([]);
    const [listSaldos, setListSaldos] = useState([]);

    const { hasPermission } = usePermissions();
    const canEditDebitoCredito = hasPermission(PERMISSIONS.DEBITO_CREDITO_EDIT);

    const mount = () => {
        setState(prevState => {
            return {...prevState,
                idCuenta: props.idCuenta,
                idTipoTributo: props.idTipoTributo
            };
        });
        SearchCuentaCorrienteCreditoSaldo(props.idCuenta);
    }
    useEffect(mount, [props.idCuenta]);

    const [ formValues, formHandle, , ] = useForm({
        detalle: ""
    });

    const { errorOf, validate } = useFormErrors(getErrors);

    const [, getRowEntidad] = useEntidad({
        entidades: ['Tasa', 'SubTasa'],
        onLoaded: (entidades, isSuccess, error) => {
          if (isSuccess) {
            setState(prevState => ({...prevState}));
          }
          else {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
          }
        }
    });

    //definiciones
    const cellSel = (props) => {
        const row = props.row.original;
        const list = (row.credito) ? listCreditos : listSaldos;
        return  <div className='action-check'>
                    {list[row.index].selectable &&
                    <input className='form-check-input' type="checkbox" value={''} checked={ list[row.index].selected } readOnly={true} />
                    }
                </div>;
    }
    const cellReservado = (props) => {
        const row = props.row.original;
        return row.reservado ? `Reservado VEP ${getNumeroRecibo_ObjectToString(row.reservado)}` : '';
    }

    const getDescTasa = (id) => {
        const row = getRowEntidad('Tasa', id);
        return (row) ? `${row.codigo} - ${row.descripcion}` : '';
    } 
    const getDescSubTasa = (id) => {
        const row = getRowEntidad('SubTasa', id);
        return (row) ? `${row.codigo} - ${row.descripcion}` : '';
    }
    
    const tableColumns = [
        { Header: '', Cell: cellSel, accessor: 'index', width:'5%', disableGlobalFilter: true, disableSortBy: true},
        { Header: 'Partida', accessor: 'numeroPartida', width: '8%', alignCell: 'right', disableSortBy: true },
        { Header: 'Tasa', Cell: (props) => getDescTasa(props.value), accessor: 'idTasa', width: '19%', disableSortBy: true },
        { Header: 'Sub tasa', Cell: (props) => getDescSubTasa(props.value), accessor: 'idSubTasa', width: '19%', disableSortBy: true },
        { Header: 'Período', accessor: 'periodo', width: '7%', alignCell: 'right', disableSortBy: true },
        { Header: 'Cuota', accessor: 'cuota', width: '6%', alignCell: 'right', disableSortBy: true },
        { Header: '1° Vto.', Cell: (props) => getDateToString(props.value, false), accessor: 'fechaVencimiento1', width: '9%' },
        { Header: 'Importe', Cell: (props) => getFormatNumber(props.value,2), accessor: 'importeSaldo', width: '13%', alignCell: 'right', disableSortBy: true },
        { Header: 'Estado', Cell: cellReservado, accessor: 'reservado', width: '14%', disableSortBy: true }
    ];


    // handlers
    const handleClickAceptar = () => {
        if (!validate()) return;

        if (!listCreditos.find(f => f.selected) || !listSaldos.find(f => f.selected)) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Debe seleccionar el origen y destino de la transferencia de crédito');
            return;
        }

        AddCuentaCredito();
    }
    const handleClickDebitosCreditos = () => {
        setState(prevState => {
            return {...prevState, showFormDebitoCredito: true};
        });
    }
    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
            const message = error.message;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
            return {...prevState, loading: false};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }
    const callbackSuccessSearchCuentaCorrienteCreditoSaldo = (response) => {
        response.json()
        .then((data) => {
            const creditosReservados = data.creditosReservados || [];
            data.cuentaCorrienteItemsCredito.forEach((item, index) => {
                item.index = index;
                item.selected = false;
                item.credito = true;
                item.reservado = creditosReservados.find(f => f.numeroPartida === item.numeroPartida) || null;
                item.selectable = !item.reservado;
            });
            data.cuentaCorrienteItemsSaldo.forEach((item, index) => {
                item.index = index;
                item.selected = false;
                item.credito = false;
                item.selectable = true;
            });

            setListCreditos(data.cuentaCorrienteItemsCredito);
            setListSaldos(data.cuentaCorrienteItemsSaldo);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }
    const callbackSuccessAddCuentaCredito = (response) => {
        response.json()
        .then((data) => {
            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "La transferencia de créditos fue realizada correctamente", () => {
                SearchCuentaCorrienteCreditoSaldo(state.idCuenta);
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.detalle.length <= 0) errors.detalle = VALIDATION_MESSAGE.REQUIRED;

        return errors;
    }
    function SearchCuentaCorrienteCreditoSaldo(idCuenta) {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const paramsUrl = `/credito-saldo/${idCuenta}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.CUENTA_CORRIENTE_ITEM,
            paramsUrl,
            null,
            callbackSuccessSearchCuentaCorrienteCreditoSaldo,
            callbackNoSuccess,
            callbackError
        );

    }
    function AddCuentaCredito() {
        setState(prevState => {
            return {...prevState, loading: true};
        });

        const numeroPartidaOrigen = listCreditos.find(f => f.selected).numeroPartida;
        const numeroPartidaDestino = listSaldos.find(f => f.selected).numeroPartida;

        const paramsUrl = `/credito`;
        const dataBody = {
            idCuenta: state.idCuenta,
            numeroPartidaOrigen: numeroPartidaOrigen,
            numeroPartidaDestino: numeroPartidaDestino,
            detalle: formValues.detalle
        };

        ServerRequest(
            REQUEST_METHOD.POST,
            null,
            true,
            APIS.URLS.CUENTA_CORRIENTE_ITEM,
            paramsUrl,
            dataBody,
            callbackSuccessAddCuentaCredito,
            callbackNoSuccess,
            callbackError
        );
    }

    return (
    <>

        <Loading visible={state.loading}></Loading>

        {state.showFormDebitoCredito && 
            <CuentaDebitosCreditosGrid
                idCuenta={state.idCuenta}
                idTipoTributo={state.idTipoTributo}
                onClickVolver={(hasChanges) => {
                    setState(prevState => {
                        return {...prevState, showFormDebitoCredito: false};
                    });
                    SearchCuentaCorrienteCreditoSaldo(props.idCuenta);
                }}
            />
        }

        <div className="row">

            <div className="mb-3 col-12">
                <FormLabel htmlFor="detalle" required>Detalle</FormLabel>
                <input
                    name="detalle"
                    type="text"
                    placeholder=""
                    className={`form-control ${errorOf('detalle') ? 'is-invalid' : ''}`}
                    value={ formValues.detalle }
                    onChange={ formHandle }
                />
                <FormError message={errorOf('detalle')} />
            </div>

            <div className="mb-3 col-12 m-top-20">

                <label className="form-label label-subtitle">Créditos a favor</label>
                <TableCustom
                    className={'TableCustomBase'}
                    columns={tableColumns}
                    data={listCreditos}
                    onClickRow={(row, cellId) => {
                        if (!listCreditos[row.index].selectable) return;
                        const list = [...listCreditos];
                        for (let index=0; index < list.length; index++) list[index].selected = false;
                        list[row.index].selected = true;
                        setListCreditos(list);
                    }}
                />

            </div>

            <div className="mb-3 col-12 m-top-20">

                <label className="form-label label-subtitle">Saldos pendientes</label>
                <TableCustom
                    className={'TableCustomBase'}
                    columns={tableColumns}
                    data={listSaldos}
                    onClickRow={(row, cellId) => {
                        const list = [...listSaldos];
                        for (let index=0; index < list.length; index++) list[index].selected = false;
                        list[row.index].selected = true;
                        setListSaldos(list);
                    }}
                />

            </div>

            <div className="col-12 m-top-50">
                {props.onClickVolver && (
                    <button className="btn back-button" data-dismiss="modal" onClick={props.onClickVolver}>Volver</button>
                )}
                <button className="btn action-button float-end m-left-10" onClick={ (event) => handleClickAceptar() } >Transferir</button>
                {canEditDebitoCredito &&
                    <button className="btn action-button float-end" onClick={ (event) => handleClickDebitosCreditos() } >Débitos y créditos</button>
                }
            </div>

        </div>

    </>
    );
}

CuentaAplicacionCreditosModal.propTypes = {
    idCuenta: number.isRequired,
    idTipoTributo: number.isRequired
};

export default CuentaAplicacionCreditosModal;